var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssignDriverInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#969696",
    d: "M12 12c2.7 0 8 1.34 8 4v3H4v-3c0-2.66 5.3-4 8-4zm0-2c-1.66 0-3-1.34-3-3S10.34 4 12 4s3 1.34 3 3-1.34 3-3 3zM6 17h12v-1c0-1.54-3.09-2.5-6-2.5S6 14.46 6 16v1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignDriverInactive);
export default __webpack_public_path__ + "static/media/assignDriverInactive.00a594484d0155aa69d042c4b72a6be4.svg";
export { ForwardRef as ReactComponent };